export default "__VITE_ASSET__B_uANAX3__";